import { apiService } from '@signals/app-shell/services/api';

const http = apiService.client;

export interface SourceCatalogEntry {
  source_id: number;
  source_name: string;
  source_type: string | null;
  data_category: string | null;
  status: string | null;
  created_by: string | null;
  track_count: number;
  last_data_at: string | null;
  last_synced_at: string | null;
  unique_entities: number;
  schema_name: string;
  table_name: string;
  geom_column: string;
}

export interface SourceCatalogResponse {
  sources: SourceCatalogEntry[];
  has_external_sources: boolean;
}

export async function fetchSourceCatalog(mine?: boolean): Promise<SourceCatalogResponse> {
  const params: Record<string, string> = {};
  if (mine) params.mine = 'true';
  const { data } = await http.get<SourceCatalogResponse>('/source-catalog/sources', { params });
  return data;
}

export async function fetchSourceGeoJson(
  sourceId: number,
  limit = 2000,
): Promise<GeoJSON.FeatureCollection> {
  const { data } = await http.get<GeoJSON.FeatureCollection>('/source-catalog/geojson', {
    params: { source_id: sourceId, limit },
  });
  return data;
}
